import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const defaultContainerProps = {
  style: {
    height: "100%",
    width: "100%",
  },
};

const Chart = (props: HighchartsReact.Props) => {
  return (
    <HighchartsReact
      highcharts={Highcharts}
      containerProps={{
        ...defaultContainerProps,
        ...props.containerProps,
      }}
      {...props}
    />
  );
};

export default Chart;
